<template>
  <Transition name="modal">
    <div v-if="showModalMain" class="modal-mask" id="modalNewsletter">
      <div class="modal-container">
        <div class="newsletterForm">
          <img
            src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
            alt="Close"
            @click="closeModalNewsletterMain()"
            class="close-modal"
          />
          <div class="newsletter-div-left">
            <img :src="imageNews" alt="Newsletter" />
          </div>
          <div class="newsletter-div-right">
            <div class="newsletter-text1">{{ translate.newspopupText1 }}</div>
            <div class="newsletter-text2">{{ translate.newspopupText2 }}</div>
            <div class="newsletter-text3">
              {{ translate.newspopupText3 }} <strong>{{ translate.newspopupText4 }}</strong>
            </div>
            <div class="newsletter-text5">{{ translate.newspopupText5 }}</div>
            <input
              class="newsletter-form-input"
              v-model="emailNews"
              type="text"
              maxlength="150"
              :placeholder="translate.newspopupPlaceholder"
            />
            <p class="newsletter-form-space">.</p>
            <input
              class="newsletter-form-button"
              type="button"
              @click="newsletterValidateEmail()"
              :value="translate.newspopupButton"
              style="
                height: 25px;
                text-transform: none;
                letter-spacing: -0.5px;
                font-weight: normal;
              "
            />
            <div class="newsletter-close">
              <a href="#" rel="nofollow" @click.prevent="closeModalNewsletterMain()">{{
                translate.newspopupClose
              }}</a>
            </div>
            <div class="newsletter-logo">
              <img
                src="https://api.belladasemana.com.br/assets/img/bella192x192.png"
                width="17"
                alt="Icon"
              />
              <p></p>
              <span>{{ translate.newspopupTitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { localeStore } from '../../stores/locale'
  import { newsletterStore } from '../../stores/newsletter'
  import newsletterTradutor from '../../tradutors/newsletter'
  import api from '../../api'
  import { userStore } from '../../stores/user'
  import { useCookies } from 'vue3-cookies'

  const { cookies } = useCookies()

  const route = useRoute()
  const storeNewsletter = newsletterStore()
  const storeUser = userStore()

  const props = defineProps({
    optionsNewsletter: {
      type: Object,
      default: () => ({})
    }
  })

  const emit = defineEmits(['showModalMessages'])

  const showModalMain = ref(false)

  // Árbitro único da tela — ver stores/modalArbiter.ts.
  const arbitro = modalArbiterStore()

  const emailNews = ref('')
  const imageNews = ref('')

  const translate = computed(() => {
    return route.params.language === 'pt-br' ? newsletterTradutor.portugues : newsletterTradutor.ingles
  })

  watch(
    () => props.optionsNewsletter,
    () => {
      if (props.optionsNewsletter.cta && !cookies.isKey('newsletterPopup')) {
        tryModalNewsletter()
      }
      if (props.optionsNewsletter.imagepath) {
        imageNews.value =
          'https://api.belladasemana.com.br/storage/newsletter/' +
          route.params.language +
          '/' +
          props.optionsNewsletter.imagepath
      }
    }
  )

  function closeModalNewsletterMain() {
    arbitro.close('modalNewsletter')
    showModalMain.value = false
  }

  function newsletterValidateEmail() {
    let requestOptions = {
      email: emailNews.value
    }
    api.post('v1/newsletter/checkMailNewsletter', requestOptions).then(({ data }) => {
      if (data['message'] == 'valido') {
        api.post('v1/newsletter/storeNewsletterApi?email=' + emailNews.value).then(({ data }) => {
          emit('showModalMessages', {
            message: {
              show: true,
              title: '',
              textBoby: data.return,
              textButton: translate.value.newspopupCloseButton,
              presente: true
            }
          })
          closeModalNewsletterMain()
        })
      } else {
        emit('showModalMessages', {
          message: {
            show: true,
            title: '',
            textBoby: data['message'],
            textButton: translate.value.newspopupCloseButton
          }
        })
      }
    })
  }
  function tryModalNewsletter() {
    var bellaTimerNewsletter = storeNewsletter.bellaTimerNewsletter
    if (!bellaTimerNewsletter.first_time_date) {
      var params = {
        first_time_date: new Date().getTime()
      }
      storeNewsletter.setNewsletterParams(params)
      bellaTimerNewsletter = storeNewsletter.bellaTimerNewsletter
    }
    var timerNews = parseInt(props.optionsNewsletter.cta) * 1000
    var currentTimeNews = new Date().getTime()
    var diffNews = currentTimeNews - Number(bellaTimerNewsletter.first_time_date)
    var timeOutNews = timerNews - diffNews < 0 ? 0 : timerNews - diffNews
    setTimeout(() => {
      if (
        arbitro.tryOpen('modalNewsletter')
      ) {
        var days7 = 1000 * 60 * 60 * 24 * 7
        cookies.set('newsletterPopup', 'true', days7)
        if (storeUser.isActiveUser == false) {
          showModalMain.value = true
        }
        storeNewsletter.resetNewsletterParams()
      }
    }, timeOutNews)
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9997;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    margin: auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    width: 636px;
    height: 467px;
    border: 0px;
    overflow: hidden;
  }

  .close-modal {
    cursor: pointer;
    position: absolute;
    left: 95.6%;
    top: 4px;
    z-index: 1;
  }

  .newsletterForm {
    display: flex;
    color: #000000;
  }

  .newsletter-div-left {
    margin-bottom: -4px;
    width: 50%;
  }

  .newsletter-div-left img {
    max-width: 100%;
    max-height: 100%;
  }

  .newsletter-div-right {
    width: 50%;
    text-align: center;
    margin: 10px auto 30px;
  }

  .newsletter-text1 {
    font-size: 19px;
    letter-spacing: -1px;
    margin-top: 45px;
  }

  .newsletter-text2 {
    margin-top: 15px;
    font-size: 46px;
    font-weight: bold;
    color: #f16400;
    letter-spacing: -1px;
    line-height: 1;
    margin-bottom: 43px;
  }

  .newsletter-text3 {
    letter-spacing: -1px;
    font-size: 17px;
  }

  .newsletter-text5 {
    margin-bottom: 20px;
    letter-spacing: -1px;
    font-size: 17px;
  }

  .newsletter-form-input {
    padding-left: 10px;
    border-radius: 10px;
    width: 90%;
    height: 25px;
    border: 1px solid #444444;
    letter-spacing: -0.6px;
    font-size: 14px;
  }

  .newsletter-form-space {
    font-size: 5px;
    margin-bottom: 0px;
  }

  .newsletter-form-button {
    border-radius: 10px;
    width: 90%;
    background-color: #f16400;
    color: #ffffff;
    border: 0;
    font-size: 14px;
  }

  .newsletter-close {
    margin-top: 12px;
  }

  .newsletter-close a {
    font-size: 10px;
    text-decoration: underline;
    cursor: pointer;
  }

  .newsletter-logo {
    margin-top: 10px;
  }

  .newsletter-logo p {
    margin: -7px;
  }

  .newsletter-logo span {
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-size: 14px;
  }

  /* regras mobile 650vp */
  @media screen and (max-width: 650px) {
    .modal-container {
      width: 95%;
      height: unset;
      overflow: hidden;
    }
    .newsletter-text1 {
      margin-top: 0px;
      font-size: 10px;
      letter-spacing: 0px;
    }

    .newsletter-text2 {
      font-size: 20px;
      margin-bottom: 10px;
      margin-top: 5px;
    }
    .newsletter-text3 {
      font-size: 10px;
      letter-spacing: 0px;      
    }
    .newsletter-text5 {
      font-size: 10px;
      margin-bottom: 10px;
      letter-spacing: 0px;
    }

    .newsletter-close {
      margin-top: 0px;
    }

    .newsletter-logo {
      margin-top: 0px;
    }
    .close-modal {
      left: 95%;
      width: 15px;
      height: 15px;
    }

    .newsletter-div-right {
      margin: 15px 2px 0px;
    }

    .newsletter-form-input {
      font-size: 10px;
    }
    .newsletter-form-button {
      font-size: 11px;
    }
  }
</style>
